import RequiresAuthCommand from '../../../Foobara/Auth/RequiresAuthCommand'

import type Inputs from './Inputs'
import type Result from './Result'
import { type Error } from './Errors'

import castJsonResult from './castJsonResult'

export class GetCurrentUser extends RequiresAuthCommand<Inputs, Result, Error> {
  static readonly organizationName = 'Foobara'
  static readonly domainName = 'Commandforge'
  static readonly commandName = 'GetCurrentUser'

  castJsonResult (json: any): Result {
    return castJsonResult(json)
  }
}
